import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ChurchPage.css';

function ChurchPage() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/church';
  };

  return (
    <div className="church-wrap">
      <header className="church-header">
        <div className="header-inner">
          <div className="user-menu">
            {user ? (
              <>
                <span className="user-name">{user.nick_name}님</span>
                <button onClick={handleLogout} className="auth-link">로그아웃</button>
              </>
            ) : (
              <>
                <Link to="/login" className="auth-link">로그인</Link>
                <Link to="/signup" className="auth-link">회원가입</Link>
              </>
            )}
          </div>
          <div className="logo-top">
            <Link to="/church" className="logo-main">
              <img src="/images/church-logo.png" alt="다비아샘터교회" />
            </Link>
          </div>
          <div className="nav-row">
            <Link to="/" className="logo-sub" title="다비아 메인으로 이동">
              <img src="/images/dasaem-logo.jpg" alt="대구성서아카데미" />
            </Link>
            <nav>
              <Link to="/">다비아 홈</Link>
              <Link to="/church">교회소개</Link>
              <Link to="/church/news">교회소식</Link>
              <Link to="/church/committee">운영위원회</Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="church-main">
        <div className="content-wrap">
          <h1>교회소개</h1>

          <section className="intro">
            <h2>다비아 샘터교회는</h2>
            <p>
              다비아 샘터교회는 2023년 1월 1일에 창립 예배를 드렸습니다. 대구성서아카데미와 함께 2000년 교회 역사의 전통 영성과 건강한 신학에 기초한 예배 공동체를 추구합니다.
            </p>
            <p>
              다비아 샘터교회는 기독교 전통 속에서 형성된 예전 예배 형식을 따르며 온·오프 병행 예배 공동체를 추구합니다. 현장 예배가 어려우신 분들도 온라인 교우로 등록하실 수 있습니다. 온라인 교우도 형편에 따라 현장예배는 물론 각종 회의, 행사에 참여하실 수 있습니다.
            </p>
          </section>

          <section className="worship">
            <h2>예배안내</h2>
            <div className="worship-grid">
              <div className="worship-card">
                <h3>현장 예배</h3>
                <ul>
                  <li><span>주일예배</span><strong>오전 11:00</strong></li>
                  <li className="worship-note">- 주일예배 현장 유튜브 실시간 방송</li>
                </ul>
              </div>
              <div className="worship-card">
                <h3>온라인 예배</h3>
                <ul>
                  <li>
                    <span>유튜브</span>
                    <div>
                      <a href="https://www.youtube.com/@%EB%8B%A4%EB%B9%84%EC%95%84%EC%83%98%ED%84%B0%EA%B5%90%ED%9A%8C" target="_blank" rel="noopener noreferrer">
                        다샘교회 유튜브 채널
                      </a>
                    </div>
                  </li>
                  <li style={{ marginTop: '10px' }}>
                    <span>설교</span>
                    <div>
                      <a href="https://www.youtube.com/@%EC%A0%95%EC%9A%A9%EC%84%AD-g9s" target="_blank" rel="noopener noreferrer">
                        정용섭 목사 채널
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="pastor">
            <h2>설교 목사 소개</h2>
            <div className="pastor-info">
              <h3>정용섭 목사</h3>
              <p className="pastor-position">다비아 샘터교회 설교 예전 목사</p>

              <div className="pastor-details">
                <div>
                  <h4>학력</h4>
                  <ul>
                    <li>서울신학대학교 졸업</li>
                    <li>서울신학대학교 대학원 석사 (한스 큉의 교회론)</li>
                    <li>독일 쾰른 대학교, 뮌스터 대학교 수학 (1983-1985)</li>
                    <li>계명대학교 대학원 신학박사 (판넨베르크의 계시론, 1993)</li>
                  </ul>
                </div>

                <div>
                  <h4>주요 경력</h4>
                  <ul>
                    <li>군목 역임 (1980-1983)</li>
                    <li>현풍제일교회 개척 및 담임 (1986-1997, 11년 6개월)</li>
                    <li>영천성결교회 담임 (1998-2000)</li>
                    <li>샘터교회 개척 및 담임 (2003년 6월 ~ 현재)</li>
                    <li>영남신학대학교 출강</li>
                  </ul>
                </div>

                <div>
                  <h4>주요 저서</h4>
                  <ul>
                    <li>『설교란 무엇인가』 (홍성사, 2011)</li>
                    <li>『주기도란 무엇인가』 (홍성사, 2011)</li>
                    <li>『설교비평집 1, 2, 3』 (기독교서회)</li>
                    <li>『기독교가 뭐꼬?』 (다비아책, 2009)</li>
                    <li>『매일 기도하라』 (한들출판사, 2013) 외 다수</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="location">
            <h2>오시는 길</h2>
            <div className="location-grid">
              <div className="contact-info">
                <dl>
                  <dt>주소</dt>
                  <dd>대구시 수성구 국채보상로 870(반지하)</dd>
                </dl>
                <dl>
                  <dt>전화</dt>
                  <dd>운영위원장 010-8588-1430</dd>
                </dl>
                <dl>
                  <dt>이메일</dt>
                  <dd><a href="mailto:freude103801@hanmail.net">freude103801@hanmail.net</a></dd>
                </dl>
                <dl>
                  <dt>웹사이트</dt>
                  <dd><a href="http://dasaem.net" target="_blank" rel="noopener noreferrer">dasaem.net</a></dd>
                </dl>
              </div>
              <div className="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.1673859765274!2d128.62586637636173!3d35.86938997252251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3565e1c455555555%3A0x1234567890abcdef!2z64yA6rWs6rSR7Jet7IucIOyImOyEsexqTAg6rWt7LGE67O07IOB66GcIDg3MA!5e0!3m2!1sko!2skr!4v1703830000000!5m2!1sko!2skr"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="다비아샘터교회 위치"
                ></iframe>
              </div>
            </div>
          </section>
        </div>
      </main>

      <footer className="church-footer">
        <div className="footer-links">
          <a href="http://dabia.net" target="_blank" rel="noopener noreferrer">대구성서아카데미</a>
          <a href="/seoul-church">서울샘터교회</a>
          <a href="https://indiadabia.blogspot.com/" target="_blank" rel="noopener noreferrer">설교링크</a>
        </div>
        <button className="scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          ↑
        </button>
      </footer>
    </div>
  );
}

export default ChurchPage;
